
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11463',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11463",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.444",
  "dashboard-client-types": "static-1.204",
  "data-fetching-client": "static-1.9447",
  "foundations-components": "static-1.7464",
  "foundations-components-legacy": "static-1.489",
  "foundations-theming": "static-1.4177",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.77",
  "head-dlb": "static-1.4754",
  "hs-test-utils": "static-1.7775",
  "hub-http-shared-msw-handlers": "static-1.9403",
  "hubspot-dlb": "static-2.1796",
  "hubspot-url-utils": "static-1.3917",
  "HubStyleTokens": "static-2.11189",
  "I18n": "static-7.1562",
  "jasmine-runner": "static-1.6242",
  "marketplace-storefront-base": "static-1.11523",
  "quartz": "static-1.6685",
  "react-dlb": "static-1.71",
  "react-rhumb": "static-1.16410",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2632",
  "reporting-testing-lib": "static-1.8321",
  "settings-ui-lib": "static-1.12289",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6669",
  "ui-addon-i18n": "static-1.10901",
  "ui-addon-react-router-dom": "static-1.9317",
  "unified-auth": "static-1.163",
  "unified-auth-core-lib": "static-1.444",
  "usage-tracker": "static-1.7102",
  "usage-tracker-core": "static-1.6952",
  "customer-data-property-utils": "static-1.7840",
  "history": "static-4.47",
  "hub-http": "static-1.5966",
  "integrations-lib": "static-1.15317",
  "marketplace-ui-common": "static-1.18858",
  "property-management-iframe": "static-1.12193",
  "quartz-config": "static-1.463",
  "quartz-core": "static-1.5904",
  "quartz-routing": "static-1.115",
  "quick-fetch": "static-1.3705",
  "react": "static-7.177",
  "rpc-client-utils": "static-1.4402",
  "ts-schema": "static-1.3876",
  "ui-universal-auth": "static-1.8649",
  "UIComponents": "static-3.8136",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "PortalIdParser": "static-2.349",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9391",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3200",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.2962",
  "quartz-webpack": "static-1.2909",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3733",
  "floating-ui": "static-1.51",
  "foundations-assets": "static-1.4602",
  "foundations-theming-specialty": "static-1.1893",
  "framer-motion": "static-1.67",
  "hs-story-utils": "static-1.9198",
  "react-aria": "static-1.61",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5145",
  "react-virtualized": "static-2.94",
  "StyleGuideUI": "static-3.483",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1109",
  "ui-fonts": "static-1.451",
  "ui-images": "static-2.1084",
  "bend-plugin-foundations-theming": "static-1.2660",
  "foundations-theming-base": "static-1.3162",
  "stylex": "static-1.27",
  "HeadJS": "static-2.704",
  "hs-test-utils-bend-plugin": "static-1.2886",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4099",
  "ai-components-ui-library": "static-1.8266",
  "ai-rendering-library": "static-1.9209",
  "chirp-fetch": "static-1.1653",
  "connections-embed-lib": "static-1.582",
  "copilot-toolkit": "static-1.10445",
  "laboratory-lib": "static-3.6932",
  "marketplace-embed": "static-1.21397",
  "marketplace-ui-details": "static-1.8754",
  "marketplace-ui-reviews": "static-1.18814",
  "marketplace-ui-tracking": "static-1.13029",
  "sanitize-text": "static-1.7910",
  "ui-addon-video-player": "static-1.8466",
  "usage-tracker-multi": "static-1.5516",
  "usage-tracker-session-replay": "static-1.4788",
  "wootric-nps": "static-1.6751",
  "apollo-link-hub-http": "static-2.4418",
  "immer": "static-1.33",
  "immerable": "static-1.3924",
  "highcharts": "static-8.99",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2378",
  "reporting-data": "static-1.66388",
  "cssUtils": "static-1.724",
  "flux-actions": "static-1.304",
  "HubStyle": "static-2.11497",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.9981",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10141",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7092",
  "icons": "static-2.618",
  "marketplace-ui-apps-core": "static-1.17391",
  "storybook-react": "static-1.28",
  "trellis-story-utils": "static-1.4293",
  "foundations-components-test-utils": "static-1.4947",
  "quartz-i18n": "static-1.360",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3501",
  "customer-data-objects": "static-1.7413",
  "property-translator": "static-1.5182",
  "frontend-preferences-client": "static-1.7693",
  "hs-promise-utils": "static-1.5361",
  "hubspot-apollo-client": "static-1.4649",
  "integrations-error-boundary-lib": "static-1.12732",
  "integrations-tracking-lib": "static-1.5353",
  "native-integrations-shared-strings": "static-1.7558",
  "reselect": "static-2.16",
  "sanitize": "static-1.4244",
  "superstore": "static-1.4540",
  "ui-shepherd-react": "static-3.9914",
  "ai-settings-ui-library": "static-1.7356",
  "hub-http-janus": "static-1.787",
  "hubspotter-http": "static-1.4449",
  "immutable-less": "static-1.4422",
  "marketplace-ui-client-types": "static-1.16265",
  "nav-meta": "static-1.28806",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10006",
  "ui-addon-upgrades": "static-9.17604",
  "inbound-db-properties-service-client": "static-1.3647",
  "property-management-common": "static-1.4480",
  "ui-addon-iframeable": "static-1.8811",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.477",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.360",
  "quartz-head": "static-1.350",
  "quartz-test": "static-1.360",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2903",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20190",
  "ContentUtils": "static-1.67532",
  "sassPrefix": "static-1.151",
  "avatar-components": "static-1.2255",
  "customer-data-filters-ui": "static-1.38775",
  "customer-data-objects-ui-components": "static-1.12773",
  "customer-data-reference-ui-components": "static-1.12913",
  "embedded-academy-lib": "static-1.13394",
  "ExportDialog": "static-6.10158",
  "highlight.js": "static-1.74",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40577",
  "reporting-snowflake": "static-1.55006",
  "reporting-ui-components": "static-2.63659",
  "reporting-visualizations": "static-1.58464",
  "ui-addon-teams": "static-1.21198",
  "magpie-lib": "static-1.5364",
  "magpie-types": "static-1.4824",
  "simple-logging-lib": "static-1.2820",
  "navigation-components": "static-1.17169",
  "ai-studio-lib": "static-1.10910",
  "developer-experience-shared-components": "static-1.10237",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7754",
  "ui-tool-access": "static-1.9913",
  "usage-based-billing-components-lib": "static-1.7930",
  "usage-tracker-anonymous": "static-1.5519",
  "usage-tracker-public": "static-1.6913",
  "amplitude-session-replay-browser": "static-1.55",
  "inbound-db-meta-service-client": "static-1.3397",
  "persist-promise": "static-1.3477",
  "reference-resolvers": "static-1.7929",
  "ui-extensibility-client-types": "static-1.3717",
  "hubspot-apollo-cache": "static-1.108",
  "universal-page-editor-lib": "static-1.2765",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2098",
  "merchandise-lib": "static-1.257",
  "atom": "static-1.4839",
  "purchase-motions-components": "static-1.5440",
  "salesImages": "static-1.520",
  "upgrade-management-service-types": "static-1.4277",
  "batch-promise": "static-1.1320",
  "crm-component-utils": "static-1.38408",
  "crm-properties-common-lib": "static-1.5641",
  "framework-data-schema-resolvers": "static-1.6639",
  "reference-resolvers-lite": "static-1.7859",
  "navigation-messaging": "static-1.6496",
  "hubspotter-http-shared-msw-handlers": "static-1.9401",
  "cms-field-types": "static-1.4575",
  "content-icons-ui": "static-1.2145",
  "conversations-skeleton-state": "static-1.7019",
  "crm-message-bus": "static-1.42257",
  "customer-data-filters-ui-msw-helpers": "static-1.21209",
  "customer-data-ui-utilities": "static-1.9594",
  "FormUrlGenerator": "static-2.4500",
  "framework-builder-read-service-client": "static-1.3817",
  "framework-data-schema-quick-fetch": "static-1.6544",
  "multi-account-reference-resolvers": "static-1.738",
  "onboarding-tours": "static-1.16216",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.12965",
  "academy-common-lib": "static-1.12854",
  "content-assistance-lib": "static-1.7404",
  "dashboard-lib": "static-1.80492",
  "file-manager-components": "static-1.22797",
  "getting-started-shared-tasks": "static-1.17793",
  "hubspot-prosemirror": "static-1.17516",
  "hubspot-prosemirror-plugins": "static-1.17508",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19421",
  "share-with-third-party-component-lib": "static-1.8460",
  "ui-addon-draggable": "static-3.4535",
  "ui-asset-management-lib": "static-1.10668",
  "ui-business-units-lib": "static-1.8792",
  "user-context": "static-1.4863",
  "growth-payments-core": "static-1.24637",
  "reporting-plugins": "static-1.9942",
  "reporting-reports": "static-1.66066",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.496",
  "codemirror": "static-5.90",
  "feedback-loader": "static-1.28796",
  "react-codemirror": "static-1.10395",
  "apps-service-types": "static-1.3648",
  "oauth-service-types": "static-1.4010",
  "onboarding-scopes": "static-1.6233",
  "onboarding-tours-client": "static-1.4430",
  "platform-infra-nav-components": "static-1.7465",
  "subscription-experience-data-types": "static-1.14548",
  "crm-record-cards-service-types": "static-1.3423",
  "location-customization-utils-lib": "static-1.8458",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4293",
  "nav-client-types": "static-1.2125",
  "purchase-motions-api": "static-1.5443",
  "signup-constants": "static-1.18329",
  "signup-ui-url-generator": "static-2.7834",
  "trials-service-types": "static-1.3694",
  "card-properties-lib": "static-1.43432",
  "crm-actions": "static-1.6065",
  "crm-cards-data": "static-1.1147",
  "crm-cards-sdk": "static-1.42818",
  "customer-data-properties": "static-1.50701",
  "customer-data-properties-shared-msw-handlers": "static-1.8730",
  "customer-data-tracking": "static-1.6651",
  "conditional-properties-service-client": "static-1.3595",
  "crm-pipelines-api-client-types": "static-1.3936",
  "multi-currency-client-types": "static-1.3490",
  "external-options-client-types": "static-1.3956",
  "react-dnd-compat": "static-1.4392",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5120",
  "growth-onboarding-confetti": "static-1.2840",
  "growth-onboarding-next-action-utils": "static-1.1264",
  "onboarding-tours-utils": "static-1.282",
  "ui-shepherd-tracker": "static-1.7295",
  "academy-service-client": "static-1.3451",
  "final-form": "static-1.65",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27862",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8154",
  "video-components-external": "static-1.10482",
  "video-data-lib": "static-1.34140",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8338",
  "payment-link-components": "static-1.22853",
  "ui-addon-emoji-picker": "static-1.9658",
  "EmailSignatureEditor": "static-1.23859",
  "viral-links-lib": "static-1.6798",
  "data-token-picker": "static-1.15993",
  "FileManagerLib": "static-1.38437",
  "react-flip-move": "static-1.65",
  "timezone-utils": "static-2.5013",
  "getting-started-shared-tasks-store": "static-1.16911",
  "campaign-roi-lib": "static-1.8182",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.160",
  "eligibility-engine-service-types": "static-1.2975",
  "crm_data": "static-4.91116",
  "crm-links": "static-1.6024",
  "customer-data-sidebar": "static-2.45331",
  "enrichment-properties-lib": "static-1.14881",
  "crm-fe-perf": "static-1.22676",
  "calling-global-api": "static-1.63550",
  "calling-internal-common": "static-1.31062",
  "calling-lifecycle-internal": "static-1.64932",
  "calling-lifecycle-messages": "static-1.57226",
  "commerce-products-lib": "static-1.8763",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.442",
  "inbounddb-objects-service-types": "static-1.4022",
  "meetings-icalendar-utils-lib": "static-1.403",
  "object-builder-ui-client": "static-1.47868",
  "pipeline-validation-client-types": "static-1.3758",
  "property-value-citations": "static-1.1315",
  "pulse": "static-1.273",
  "smart-property-lib": "static-1.5763",
  "tiered-pricing": "static-1.782",
  "ui-addon-form-validation": "static-1.10764",
  "growth-onboarding-feedback-components": "static-1.6355",
  "content-media-composition-data-lib": "static-1.11340",
  "content-media-compositions": "static-2.15347",
  "media-bridge-lib": "static-1.18515",
  "commerce-tours-lib": "static-1.5672",
  "growth-onboarding-reliability": "static-1.4858",
  "sales-checkout-service-client": "static-1.3447",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21259",
  "sales-email-signature-service-client": "static-1.3614",
  "audio-components": "static-1.5568",
  "FileManagerCore": "static-1.38296",
  "FileManagerImages": "static-1.35948",
  "video-components": "static-1.12485",
  "crm_universal": "static-1.21611",
  "customer-data-email": "static-1.17619",
  "calling-error-reporting": "static-1.31068",
  "card-payment-highlight-lib": "static-1.36414",
  "card-subscription-highlight-lib": "static-1.38771",
  "commerce-billing-lib": "static-1.18412",
  "commerce-contract-lib": "static-1.11047",
  "customer-data-content": "static-1.26821",
  "invoices-highlight-card-lib": "static-1.53908",
  "orders-highlight-card-lib": "static-1.20798",
  "products-highlight-card-lib": "static-1.17047",
  "project-storage": "static-1.4502",
  "quotes-highlight-card-lib": "static-1.71041",
  "breeze-intelligence-kit": "static-1.5276",
  "crm-source-interpretation-lib": "static-1.5100",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9486",
  "policy-lib": "static-1.6554",
  "shared-worker-versioning": "static-1.10806",
  "calling-usage-tracker": "static-1.6307",
  "voice-sms-access-library": "static-1.152",
  "products-iframe-lib": "static-1.7231",
  "products-ui-components-shared-msw-handlers": "static-1.9785",
  "directed-graph": "static-1.707",
  "event-emitter": "static-1.716",
  "react-tinymce": "static-1.54537",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9549",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53663",
  "tinymce-plugins": "static-1.56777",
  "tinymce-themes": "static-1.55633",
  "hls.js": "static-1.34",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4304",
  "video-embed": "static-1.34974",
  "social-insights-client-types": "static-1.21265",
  "sequences-lib": "static-1.7641",
  "ui-gdpr-components": "static-1.10116",
  "commerce-shared-components-lib": "static-1.17837",
  "commerce-subscription-lib": "static-1.36348",
  "commerce-tools-ui-lib": "static-1.9716",
  "utility-belt": "static-1.2312",
  "payments-enrollment-embed-lib": "static-1.21885",
  "products-ui-components": "static-1.39282",
  "quotes-client-types": "static-1.37129",
  "quotes-ui-lib": "static-1.79760",
  "SalesContentIndexUI": "static-3.8855",
  "accounting-integrations-ui-components": "static-1.6679",
  "invoices-ui-lib": "static-1.53924",
  "commerce-products-api": "static-1.1912",
  "SafeStorage": "static-1.4174",
  "invoices-iframe-lib": "static-1.55982",
  "quotes-modal-lib": "static-1.101717",
  "calling-orchestration-schema": "static-1.34929",
  "sales-views-client-types": "static-1.4061",
  "hub-http-contrib": "static-1.2814",
  "interframe": "static-3.4561",
  "tinymce-data": "static-1.39748",
  "ui-addon-sales-email": "static-1.4983",
  "layout-dnd-components": "static-1.11977",
  "layout-dnd-utils": "static-1.10952",
  "ui-brand-identity-lib": "static-1.13724",
  "NamespacedHubStyle": "static-2.8868",
  "outpost": "static-1.3976",
  "sequences-client-types-lib": "static-1.7498",
  "customer-data-associations": "static-1.7105",
  "framework-data-table": "static-2.11341",
  "customer-data-rte": "static-1.32373",
  "cv-backend-services": "static-1.1490",
  "growth-onboarding-empty-states": "static-1.5318",
  "InboxConnectUtils": "static-4.14143",
  "payments-post-enroll-local-storage-lib": "static-1.4881",
  "qrcode-generator": "static-1.64",
  "stripe-embedded-components": "static-1.7083",
  "commerce-permissions": "static-1.522",
  "commerce-tax-lib": "static-1.279",
  "property-description-translator": "static-1.3628",
  "FireAlarmUi": "static-1.4299",
  "sales-templates-service-types-lib": "static-1.3966",
  "commerce-analytics-service-client": "static-1.3435",
  "totals-ui-components": "static-1.22922",
  "ContentData": "static-1.67607",
  "layout-data-lib": "static-1.9277",
  "deal-intel-decorators": "static-1.1131",
  "tanstack-virtual": "static-1.25",
  "draft-content-plugins": "static-1.27641",
  "stripe-connect-js": "static-1.63",
  "commerce-totals-service-types": "static-1.3610",
  "advanced-menus-core": "static-1.14771",
  "advanced-menus-lib": "static-1.11753",
  "ui-memberships-settings-lib": "static-1.33346",
  "deal-intel-utils": "static-1.1135",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14770",
  "simple-menus-lib": "static-1.16287"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11463",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.444",
  "dashboard-client-types": "/dashboard-client-types/static-1.204",
  "data-fetching-client": "/data-fetching-client/static-1.9447",
  "foundations-components": "/foundations-components/static-1.7464",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.489",
  "foundations-theming": "/foundations-theming/static-1.4177",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.77",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-test-utils": "/hs-test-utils/static-1.7775",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9403",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyleTokens": "/HubStyleTokens/static-2.11189",
  "I18n": "/I18n/static-7.1562",
  "jasmine-runner": "/jasmine-runner/static-1.6242",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11523",
  "quartz": "/quartz/static-1.6685",
  "react-dlb": "/react-dlb/static-1.71",
  "react-rhumb": "/react-rhumb/static-1.16410",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2632",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8321",
  "settings-ui-lib": "/settings-ui-lib/static-1.12289",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6669",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10901",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9317",
  "unified-auth": "/unified-auth/static-1.163",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.444",
  "usage-tracker": "/usage-tracker/static-1.7102",
  "usage-tracker-core": "/usage-tracker-core/static-1.6952",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7840",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5966",
  "integrations-lib": "/integrations-lib/static-1.15317",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.18858",
  "property-management-iframe": "/property-management-iframe/static-1.12193",
  "quartz-config": "/quartz-config/static-1.463",
  "quartz-core": "/quartz-core/static-1.5904",
  "quartz-routing": "/quartz-routing/static-1.115",
  "quick-fetch": "/quick-fetch/static-1.3705",
  "react": "/react/static-7.177",
  "rpc-client-utils": "/rpc-client-utils/static-1.4402",
  "ts-schema": "/ts-schema/static-1.3876",
  "ui-universal-auth": "/ui-universal-auth/static-1.8649",
  "UIComponents": "/UIComponents/static-3.8136",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9391",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3200",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2962",
  "quartz-webpack": "/quartz-webpack/static-1.2909",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3733",
  "floating-ui": "/floating-ui/static-1.51",
  "foundations-assets": "/foundations-assets/static-1.4602",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1893",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9198",
  "react-aria": "/react-aria/static-1.61",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5145",
  "react-virtualized": "/react-virtualized/static-2.94",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1109",
  "ui-fonts": "/ui-fonts/static-1.451",
  "ui-images": "/ui-images/static-2.1084",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2660",
  "foundations-theming-base": "/foundations-theming-base/static-1.3162",
  "stylex": "/stylex/static-1.27",
  "HeadJS": "/HeadJS/static-2.704",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2886",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4099",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8266",
  "ai-rendering-library": "/ai-rendering-library/static-1.9209",
  "chirp-fetch": "/chirp-fetch/static-1.1653",
  "connections-embed-lib": "/connections-embed-lib/static-1.582",
  "copilot-toolkit": "/copilot-toolkit/static-1.10445",
  "laboratory-lib": "/laboratory-lib/static-3.6932",
  "marketplace-embed": "/marketplace-embed/static-1.21397",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8754",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18814",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13029",
  "sanitize-text": "/sanitize-text/static-1.7910",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8466",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5516",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4788",
  "wootric-nps": "/wootric-nps/static-1.6751",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4418",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3924",
  "highcharts": "/highcharts/static-8.99",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2378",
  "reporting-data": "/reporting-data/static-1.66388",
  "cssUtils": "/cssUtils/static-1.724",
  "flux-actions": "/flux-actions/static-1.304",
  "HubStyle": "/HubStyle/static-2.11497",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.9981",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10141",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7092",
  "icons": "/icons/static-2.618",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17391",
  "storybook-react": "/storybook-react/static-1.28",
  "trellis-story-utils": "/trellis-story-utils/static-1.4293",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4947",
  "quartz-i18n": "/quartz-i18n/static-1.360",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3501",
  "customer-data-objects": "/customer-data-objects/static-1.7413",
  "property-translator": "/property-translator/static-1.5182",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7693",
  "hs-promise-utils": "/hs-promise-utils/static-1.5361",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4649",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12732",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5353",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7558",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4244",
  "superstore": "/superstore/static-1.4540",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9914",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7356",
  "hub-http-janus": "/hub-http-janus/static-1.787",
  "hubspotter-http": "/hubspotter-http/static-1.4449",
  "immutable-less": "/immutable-less/static-1.4422",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16265",
  "nav-meta": "/nav-meta/static-1.28806",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10006",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17604",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3647",
  "property-management-common": "/property-management-common/static-1.4480",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8811",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.477",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.360",
  "quartz-head": "/quartz-head/static-1.350",
  "quartz-test": "/quartz-test/static-1.360",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2903",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20190",
  "ContentUtils": "/ContentUtils/static-1.67532",
  "sassPrefix": "/sassPrefix/static-1.151",
  "avatar-components": "/avatar-components/static-1.2255",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38775",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12773",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12913",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13394",
  "ExportDialog": "/ExportDialog/static-6.10158",
  "highlight.js": "/highlight.js/static-1.74",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40577",
  "reporting-snowflake": "/reporting-snowflake/static-1.55006",
  "reporting-ui-components": "/reporting-ui-components/static-2.63659",
  "reporting-visualizations": "/reporting-visualizations/static-1.58464",
  "ui-addon-teams": "/ui-addon-teams/static-1.21198",
  "magpie-lib": "/magpie-lib/static-1.5364",
  "magpie-types": "/magpie-types/static-1.4824",
  "simple-logging-lib": "/simple-logging-lib/static-1.2820",
  "navigation-components": "/navigation-components/static-1.17169",
  "ai-studio-lib": "/ai-studio-lib/static-1.10910",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10237",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7754",
  "ui-tool-access": "/ui-tool-access/static-1.9913",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7930",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5519",
  "usage-tracker-public": "/usage-tracker-public/static-1.6913",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "persist-promise": "/persist-promise/static-1.3477",
  "reference-resolvers": "/reference-resolvers/static-1.7929",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3717",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.108",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2765",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2098",
  "merchandise-lib": "/merchandise-lib/static-1.257",
  "atom": "/atom/static-1.4839",
  "purchase-motions-components": "/purchase-motions-components/static-1.5440",
  "salesImages": "/salesImages/static-1.520",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4277",
  "batch-promise": "/batch-promise/static-1.1320",
  "crm-component-utils": "/crm-component-utils/static-1.38408",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5641",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6639",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7859",
  "navigation-messaging": "/navigation-messaging/static-1.6496",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9401",
  "cms-field-types": "/cms-field-types/static-1.4575",
  "content-icons-ui": "/content-icons-ui/static-1.2145",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7019",
  "crm-message-bus": "/crm-message-bus/static-1.42257",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21209",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9594",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4500",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3817",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6544",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.738",
  "onboarding-tours": "/onboarding-tours/static-1.16216",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.12965",
  "academy-common-lib": "/academy-common-lib/static-1.12854",
  "content-assistance-lib": "/content-assistance-lib/static-1.7404",
  "dashboard-lib": "/dashboard-lib/static-1.80492",
  "file-manager-components": "/file-manager-components/static-1.22797",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17793",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17516",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17508",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19421",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8460",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4535",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10668",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8792",
  "user-context": "/user-context/static-1.4863",
  "growth-payments-core": "/growth-payments-core/static-1.24637",
  "reporting-plugins": "/reporting-plugins/static-1.9942",
  "reporting-reports": "/reporting-reports/static-1.66066",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.496",
  "codemirror": "/codemirror/static-5.90",
  "feedback-loader": "/feedback-loader/static-1.28796",
  "react-codemirror": "/react-codemirror/static-1.10395",
  "apps-service-types": "/apps-service-types/static-1.3648",
  "oauth-service-types": "/oauth-service-types/static-1.4010",
  "onboarding-scopes": "/onboarding-scopes/static-1.6233",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4430",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7465",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14548",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3423",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8458",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4293",
  "nav-client-types": "/nav-client-types/static-1.2125",
  "purchase-motions-api": "/purchase-motions-api/static-1.5443",
  "signup-constants": "/signup-constants/static-1.18329",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7834",
  "trials-service-types": "/trials-service-types/static-1.3694",
  "card-properties-lib": "/card-properties-lib/static-1.43432",
  "crm-actions": "/crm-actions/static-1.6065",
  "crm-cards-data": "/crm-cards-data/static-1.1147",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42818",
  "customer-data-properties": "/customer-data-properties/static-1.50701",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8730",
  "customer-data-tracking": "/customer-data-tracking/static-1.6651",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3595",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3936",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3490",
  "external-options-client-types": "/external-options-client-types/static-1.3956",
  "react-dnd-compat": "/react-dnd-compat/static-1.4392",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5120",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2840",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1264",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.282",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7295",
  "academy-service-client": "/academy-service-client/static-1.3451",
  "final-form": "/final-form/static-1.65",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27862",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8154",
  "video-components-external": "/video-components-external/static-1.10482",
  "video-data-lib": "/video-data-lib/static-1.34140",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8338",
  "payment-link-components": "/payment-link-components/static-1.22853",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9658",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23859",
  "viral-links-lib": "/viral-links-lib/static-1.6798",
  "data-token-picker": "/data-token-picker/static-1.15993",
  "FileManagerLib": "/FileManagerLib/static-1.38437",
  "react-flip-move": "/react-flip-move/static-1.65",
  "timezone-utils": "/timezone-utils/static-2.5013",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16911",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8182",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.160",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2975",
  "crm_data": "/crm_data/static-4.91116",
  "crm-links": "/crm-links/static-1.6024",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45331",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.14881",
  "crm-fe-perf": "/crm-fe-perf/static-1.22676",
  "calling-global-api": "/calling-global-api/static-1.63550",
  "calling-internal-common": "/calling-internal-common/static-1.31062",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64932",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57226",
  "commerce-products-lib": "/commerce-products-lib/static-1.8763",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.442",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4022",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.403",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47868",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3758",
  "property-value-citations": "/property-value-citations/static-1.1315",
  "pulse": "/pulse/static-1.273",
  "smart-property-lib": "/smart-property-lib/static-1.5763",
  "tiered-pricing": "/tiered-pricing/static-1.782",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10764",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6355",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11340",
  "content-media-compositions": "/content-media-compositions/static-2.15347",
  "media-bridge-lib": "/media-bridge-lib/static-1.18515",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5672",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4858",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3447",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21259",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3614",
  "audio-components": "/audio-components/static-1.5568",
  "FileManagerCore": "/FileManagerCore/static-1.38296",
  "FileManagerImages": "/FileManagerImages/static-1.35948",
  "video-components": "/video-components/static-1.12485",
  "crm_universal": "/crm_universal/static-1.21611",
  "customer-data-email": "/customer-data-email/static-1.17619",
  "calling-error-reporting": "/calling-error-reporting/static-1.31068",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36414",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38771",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18412",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11047",
  "customer-data-content": "/customer-data-content/static-1.26821",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.53908",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20798",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17047",
  "project-storage": "/project-storage/static-1.4502",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71041",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5276",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5100",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9486",
  "policy-lib": "/policy-lib/static-1.6554",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10806",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6307",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.152",
  "products-iframe-lib": "/products-iframe-lib/static-1.7231",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9785",
  "directed-graph": "/directed-graph/static-1.707",
  "event-emitter": "/event-emitter/static-1.716",
  "react-tinymce": "/react-tinymce/static-1.54537",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9549",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53663",
  "tinymce-plugins": "/tinymce-plugins/static-1.56777",
  "tinymce-themes": "/tinymce-themes/static-1.55633",
  "hls.js": "/hls.js/static-1.34",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4304",
  "video-embed": "/video-embed/static-1.34974",
  "social-insights-client-types": "/social-insights-client-types/static-1.21265",
  "sequences-lib": "/sequences-lib/static-1.7641",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10116",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17837",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36348",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9716",
  "utility-belt": "/utility-belt/static-1.2312",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.21885",
  "products-ui-components": "/products-ui-components/static-1.39282",
  "quotes-client-types": "/quotes-client-types/static-1.37129",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.79760",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8855",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6679",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.53924",
  "commerce-products-api": "/commerce-products-api/static-1.1912",
  "SafeStorage": "/SafeStorage/static-1.4174",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.55982",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101717",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34929",
  "sales-views-client-types": "/sales-views-client-types/static-1.4061",
  "hub-http-contrib": "/hub-http-contrib/static-1.2814",
  "interframe": "/interframe/static-3.4561",
  "tinymce-data": "/tinymce-data/static-1.39748",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4983",
  "layout-dnd-components": "/layout-dnd-components/static-1.11977",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10952",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13724",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8868",
  "outpost": "/outpost/static-1.3976",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7498",
  "customer-data-associations": "/customer-data-associations/static-1.7105",
  "framework-data-table": "/framework-data-table/static-2.11341",
  "customer-data-rte": "/customer-data-rte/static-1.32373",
  "cv-backend-services": "/cv-backend-services/static-1.1490",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5318",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14143",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4881",
  "qrcode-generator": "/qrcode-generator/static-1.64",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7083",
  "commerce-permissions": "/commerce-permissions/static-1.522",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.279",
  "property-description-translator": "/property-description-translator/static-1.3628",
  "FireAlarmUi": "/FireAlarmUi/static-1.4299",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3966",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3435",
  "totals-ui-components": "/totals-ui-components/static-1.22922",
  "ContentData": "/ContentData/static-1.67607",
  "layout-data-lib": "/layout-data-lib/static-1.9277",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1131",
  "tanstack-virtual": "/tanstack-virtual/static-1.25",
  "draft-content-plugins": "/draft-content-plugins/static-1.27641",
  "stripe-connect-js": "/stripe-connect-js/static-1.63",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3610",
  "advanced-menus-core": "/advanced-menus-core/static-1.14771",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11753",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33346",
  "deal-intel-utils": "/deal-intel-utils/static-1.1135",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14770",
  "simple-menus-lib": "/simple-menus-lib/static-1.16287"
}
};
